import React from "react";
function FeatureImage() {
    return (<>
        <img></img>
    </>);
}

export default FeatureImage;